<template>
  <SupportBlock @go="toTutorial">
    <template v-slot:message>{{ $t("banner.tutorialDesc") }}</template>
    <template v-slot:action>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2.5" y="12.5" width="10.8333" height="1.66667" fill="url(#paint0_linear)" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.334 4.16666H2.50065C1.58018 4.16666 0.833984 4.91285 0.833984 5.83332V14.1667C0.833984 15.0871 1.58018 15.8333 2.50065 15.8333H13.334C14.2545 15.8333 15.0007 15.0871 15.0007 14.1667V12.4264L17.9284 14.0652C18.4868 14.364 19.1673 13.967 19.1673 13.3425V6.65752C19.1673 6.03295 18.4868 5.63597 17.9284 5.93481L15.0007 7.57954V5.83332C15.0007 4.91285 14.2545 4.16666 13.334 4.16666ZM2.50065 10.8333V5.83332H13.334V10.8333H2.50065ZM2.50065 12.5V14.1667H13.334V12.5H2.50065ZM14.1673 10.051L17.4638 8.06974V12.0322L14.1673 10.051ZM11.6673 8.74999C10.977 8.74999 10.4173 8.19035 10.4173 7.49999C10.4173 6.80963 10.977 6.24999 11.6673 6.24999C12.3577 6.24999 12.9173 6.80963 12.9173 7.49999C12.9173 8.19035 12.3577 8.74999 11.6673 8.74999Z" fill="#0060E5" />
        <defs>
          <linearGradient id="paint0_linear" x1="7.83825" y1="11.7634" x2="7.36275" y2="14.8542" gradientUnits="userSpaceOnUse">
            <stop stop-color="#ECF3FE" />
            <stop offset="1" stop-color="#C6DAFD" />
          </linearGradient>
        </defs>
      </svg>
      {{ $t("banner.tutorial") }}
    </template>
  </SupportBlock>
</template>

<script>
import SupportBlock from "../SupportBlock";
export default {
  name: "Tutorial",
  components: {
    SupportBlock
  },
  methods: {
    toTutorial() {
      this.$router.replace({ name: "Tutorials" });
    }
  }
};
</script>
